var exports = {
  "e6": "AddFavoriteChannelModal.module__selectContainer___R0Jwd2",
  "yc": "AddFavoriteChannelModal.module__checkboxRow___R0Jwd2",
  "Dq": "AddFavoriteChannelModal.module__checkboxText___R0Jwd2",
  "gs": "AddFavoriteChannelModal.module__scrollerContainer___R0Jwd2",
  "o5": "AddFavoriteChannelModal.module__channelList___R0Jwd2",
  "p$": "AddFavoriteChannelModal.module__emptyState___R0Jwd2",
  "Km": "AddFavoriteChannelModal.module__categoryHeader___R0Jwd2",
  "WG": "AddFavoriteChannelModal.module__channelRow___R0Jwd2",
  "uM": "AddFavoriteChannelModal.module__channelIconContainer___R0Jwd2",
  "p": "AddFavoriteChannelModal.module__channelIcon___R0Jwd2",
  "HA": "AddFavoriteChannelModal.module__channelName___R0Jwd2",
  "tN": "AddFavoriteChannelModal.module__channelActions___R0Jwd2",
};

module.exports = exports;
